import { Flame, Sparkles, Clock, CalendarDays, Ticket, Mic, Disc3, Music } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const SOLID = {
  Populaire: "bg-[#2563EB] text-white",
  "Soirée": "bg-[#9333EA] text-white",
  Nouveau: "bg-[#16A34A] text-white",
  Ouvert: "bg-[#16A34A] text-white",
  "Événement": "bg-[#2563EB] text-white",
  "Activité": "bg-[#F97316] text-white",
  "Karaoké": "bg-[#9333EA] text-white",
  "Soirée DJ": "bg-[#2563EB] text-white",
  "Concert Live": "bg-[#EC4899] text-white",
};

const SOFT = {
  Populaire: "bg-blue-50 text-blue-700",
  "Soirée": "bg-purple-50 text-purple-700",
  Nouveau: "bg-emerald-50 text-emerald-700",
  Ouvert: "bg-emerald-50 text-emerald-700",
  "Événement": "bg-blue-50 text-blue-700",
  "Activité": "bg-orange-50 text-orange-700",
  "Karaoké": "bg-purple-50 text-purple-700",
  "Soirée DJ": "bg-blue-50 text-blue-700",
  "Concert Live": "bg-pink-50 text-pink-700",
};

const ICONS = {
  Populaire: Flame,
  "Soirée": Sparkles,
  Nouveau: Sparkles,
  Ouvert: Clock,
  "Événement": CalendarDays,
  "Activité": Ticket,
  "Karaoké": Mic,
  "Soirée DJ": Disc3,
  "Concert Live": Music,
};

export const StatusBadge = ({ badge, soft = false }) => {
  const { t } = useLanguage();
  if (!badge) return null;
  const Icon = ICONS[badge];
  const style = soft ? SOFT[badge] : SOLID[badge];
  return (
    <span
      data-testid={`badge-${badge.toLowerCase().replace(/[^a-z]/g, "")}`}
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold ${style || "bg-slate-100 text-slate-600"}`}
    >
      {Icon && <Icon className="h-3 w-3" />}
      {t(badge)}
    </span>
  );
};
